import {createFeatureFlagsStore} from '#imports';

export const useFeatureFlagsStoreUnlogged = createFeatureFlagsStore(
    ['one-entry-point-improvements', 'enable-auth-link'],
    'navbar-module-feature-flags',
);
